// src/plugins/axios.js  
import axios from 'axios';  
import router from '@/router'

// import router from '@/router'; // 确认路径正确
// import Vue from 'vue'   //引入Vue
// import Router from 'vue-router'  //引入vue-router
// Vue.use(Router)
// 创建一个 Axios 实例  
const axiosInstance = axios.create({  
  baseURL: '', // 发布版本 URL  
  //  baseURL: '/api', // 本地调试 URL  
  timeout: 1000000, // 请求超时时间  
  headers: { 'Content-Type': 'application/json' } // 默认请求头  
});  
  
// 添加请求拦截器  
axiosInstance.interceptors.request.use(  
  config => {  
    // 在发送请求之前做些什么，比如添加认证 token  
    const token = localStorage.getItem('token');  
    if (token) {  
      console.log('此时有没有token',token)
      config.headers.Authorization = `Bearer ${token}`;  
    }  
    return config;  
  },  
  error => {  
    // 对请求错误做些什么  
    return Promise.reject(error);  
  }  
);  
  
// 添加响应拦截器  
axiosInstance.interceptors.response.use(  
  response => {  
    // 对响应数据做点什么  
    return response.data;  
  },  
  error => {  
    // 对响应错误做点什么  
    if (error.response && error.response.status === 401) {  
      console.log('到这里了吗')
      // 处理未授权错误，比如重定向到登录页面 
      localStorage.removeItem('token');
      const token = localStorage.getItem('token');
      console.log('此时token去掉了没',token)
      router.push('/login');
      // window.location.href = '/login'; 
      return Promise.reject(error);  
      
    }  
    return Promise.reject(error);  
  }  
);  
  
export default axiosInstance;